import { Component, Vue, Watch } from 'types-vue'
import CCPService from '../../Services/CCP'

@Component
export default class DataContainer extends Vue {

  protected loading: boolean = true
  protected setIntervalFun: any

  @Watch('loading')
  onChangeLoading(newValue: boolean) {
    if (!!newValue) return
    clearInterval(this.setIntervalFun)
  }

  /**
   * VUE EVENTS
   */

  protected async mounted() {
    this.setIntervalFun = setInterval(async () => {
      const agent = await CCPService.getAgent()
      this.loading = !agent.getStatus()
    }, 500)
  }
}